import {
  ApiPostRequestParams,
  ApiService,
  ApiServiceGetResponse,
} from '@services'
import { MainInventoryBackendCard } from '@store'

export const getInventoryApi = async (): Promise<
  ApiServiceGetResponse<MainInventoryBackendCard[]>
> => {
  let allInventory: MainInventoryBackendCard[] | undefined = undefined;
  let page = 0;

  while (true) {
    const res = await ApiService.get({
      endpoint: '/api/v1/inventory',
      options: { page },
    });
 
    if (!res.ok || !res.data) {
      return { ok: res.ok, data: allInventory  };
    }

    const batch = res.data ?? [];
    if (!allInventory) {
      allInventory = [];
    } 
    allInventory.push(...batch);

    if (batch.length < 200) break;
    page += 1;
  }

  return { ok: true, data: allInventory };
};

export const consumeItemApi = async (
  id: string,
  additionalData?: Record<string, any>
): Promise<ApiServiceGetResponse<any>> => {
  const request: ApiPostRequestParams = {
    endpoint: `/api/v1/inventory/item/${id}/consume`,
  }
  if (additionalData) {
    request.data = { additional_data: additionalData }
  }

  const { ok, data } = await ApiService.post(request)

  return { ok, data: data || null }
}
